module.exports = __webpack_public_path__ + "static/problem-intro-d-e211fa885d13b67d75f1a43a387accb6.jpg";